import { create } from "zustand";
import { fetchEmployeeNamesListService } from "../services/employeeNamesListServices";

export const useEmployeeNamesListStore = create((set) => ({
  employeeList: [],
  loading: false,
  fetchEmployees: async () => {
    await fetchEmployeeNamesListService(set);
  },
}));
